import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
} from "antd";

import { useBackend } from "backend/useBackend";

const { Content } = Layout;

const endpoint = "topics";

const Edit = () => {
  const { state } = useLocation();
  const { updateItem } = useBackend();

  const navigate = useNavigate();

  const onFinish = (values) => {
    const payload = {
      ...values,
    };
    // console.log(payload)
    updateItem(endpoint, state.id, payload, {
      redirectTo: endpoint,
      msg: {
        loading: "Updating...",
        success: "Updated successfully.",
      },
      loading: true,
    });
  };

  const onFinishFailed = (error) => console.log(error);

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Topics</Breadcrumb.Item>
        <Breadcrumb.Item>Edit</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={12}>
          <Card title="Edit Details">
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={state}
              size={"large"}
            >
              <Row gutter={24}>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Name"
                    name="name"
                    rules={[
                      { required: true, message: "Name is required" },
                    ]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Slug"
                    name="slug"
                    rules={[
                      { required: true, message: "Slug is required" },
                    ]}
                    size={"large"}
                  >
                    <Input placeholder="Slug" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="mb-2"
                label="Description"
                name="description"
                rules={[{ required: true, message: "Description is required" }]}
                size={"large"}
              >
                <Input.TextArea placeholder="Description" />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Update
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Edit;
